export default {
  MAP_BOUNDS: "MAP_BOUNDS", //mapbox bounds
  SET_IS_LOADING: "SET_IS_LOADING",
};
